module.exports = __webpack_public_path__ + "static/media/gb-nir.5b44fea7.svg";